import React, { forwardRef, useEffect, useState, useCallback, useImperativeHandle, useRef } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { createOptions } from '../../../../Components/helper';
import BasicLibraryDetailComponent from './BasicLibraryDetail';
import LibraryPagesComponent from './LibraryPages';

function Builder(
  {
    pageId,
    errorFields,
    productTypeOptions,
    brandsOptions,
    allSupplierList,
    isGrdiVisible,
    libraryAllData,
    pageLoading,
    isSubBrandAccess,
    subBrandOptions,
    setSubBrandOptions,
    ...props
  },
  ref,
) {
  const reducer = useSelector((reducerstate) => reducerstate);

  const { CustomModuleReducer } = reducer;
  const { customLibraryDetail, customModulePageList } = CustomModuleReducer;
  const a4PageRef = useRef(null);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [libraryBasicData, setLibraryBasicData] = useState({
    moduleName: '',
    productTypeId: null,
    brandId: null,
    supplierId: null,
    isActive: true,
    isDeleted: false,
    subBrandId: [],
  });

  useImperativeHandle(ref, () => ({
    getBasicLibraryData() {
      return libraryBasicData;
    },
    getActivePageData() {
      return a4PageRef.current ? a4PageRef.current.getActivePageData() : null;
    },
  }));

  useEffect(() => {
    if (customLibraryDetail) {
      setLibraryBasicData((prevState) => ({
        ...prevState,
        moduleName: customLibraryDetail?.moduleName,
        productTypeId: customLibraryDetail?.productTypeId,
        brandId: customLibraryDetail?.brandId,
        supplierId: customLibraryDetail?.supplierId,
        subBrandId: customLibraryDetail?.subBrandId || [],
      }));
    }
  }, [customLibraryDetail]);

  // useEffect for productTypeId change
  useEffect(() => {
    if (libraryBasicData?.productTypeId) {
      const ids = libraryBasicData.productTypeId?.map((ele) => ele.value);
      const list = allSupplierList?.filter((element) => {
        // check if element.supplierType includes any of the ids
        return ids?.some((id) => element?.supplierType?.includes(id));
      });

      setSupplierOptions(createOptions(list, 'name', '_id'));
    }
  }, [libraryBasicData?.productTypeId, allSupplierList]);

  const handleBasicDetail = useCallback((key, value) => {
    setLibraryBasicData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  }, []);

  useEffect(() => {
    if (isEmpty(libraryBasicData?.brandId)) {
      setLibraryBasicData((prevState) => ({
        ...prevState,
        subBrandId: [],
      }));
      setSubBrandOptions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryBasicData?.brandId]);

  return (
    <div className="module-builder-container">
      <BasicLibraryDetailComponent
        libraryData={libraryBasicData}
        errorFields={errorFields}
        handleBasicDetail={handleBasicDetail}
        brandsOptions={brandsOptions || []}
        productTypeOptions={productTypeOptions || []}
        supplierOptions={supplierOptions || []}
        isSubBrandAccess={isSubBrandAccess}
        subBrandOptions={subBrandOptions}
      />
      {pageLoading ? (
        <Loader />
      ) : (
        Array.isArray(libraryAllData?.pages) &&
        libraryAllData?.pages?.map((page, index) => (
          <LibraryPagesComponent
            totalPages={customModulePageList?.pages?.length || 0}
            key={page?.uniqueKey}
            pageId={pageId}
            page={page}
            index={index}
            isGrdiVisible={isGrdiVisible}
            ref={a4PageRef}
            {...props}
          />
        ))
      )}
    </div>
  );
}
const ModuleBuilder = forwardRef(Builder);
export default React.memo(ModuleBuilder);
